import { useState, useEffect } from 'react';
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Helmet } from 'react-helmet-async';
import { Link, Link as RouterLink, useNavigate, NavLink,useParams } from 'react-router-dom';
import DataTable from 'react-data-table-component';
import DataTableExtensions from "react-data-table-component-extensions";
import "react-data-table-component-extensions/dist/index.css";
import { saveAs } from 'file-saver';
import * as XLSX from 'xlsx'; // Import XLSX library properly
// @mui
import { styled } from '@mui/material/styles';
import { Button, Typography, Container, Box, Modal } from '@mui/material';

import * as userActions from "../../actions/userActions";
import config from "../../config";
import { encryptData } from '../../utils/cryptoUtils';

import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap/dist/js/bootstrap.bundle';
import "bootstrap-icons/font/bootstrap-icons.css";
import '../common.scss';
import * as leadActions from "../../actions/leadActions";
import * as campaignsActions from "../../actions/campaignsActions";

import AccessDeniedWithoutLeftMenu from '../common/AccessDeniedWithoutLeftMenu';

// ----------------------------------------------------------------------

const StyledContent = styled('div')(({ theme }) => ({
    maxWidth: 480,
    margin: 'auto',
    minHeight: '100vh',
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column',
    padding: theme.spacing(12, 0),
}));

// ----------------------------------------------------------------------

const CkersFinanceCombineReport = (props) => {
    const { brief } = useParams();
    const { param1 } = useParams();
    
     const { actions, campaignData } = props; 
    const navigate = useNavigate();
    const [open, setOpen] = useState(false);
    const [pageHeading , setPageHeading]  = useState('');
    const [iframeSrc , setIframeSrc]  = useState('');
    const [iframeLoaded, setIframeLoaded] = useState(false);


    const randomNumberInRange = (min, max) => {
        return Math.floor(Math.random()
            * (max - min + 1)) + min;
    };

    useEffect(() => {  
        let appUrl = config.APP_URL;
        appUrl = appUrl.replace('/public/', '/');
            setPageHeading('Ckers Finance Combine Report');
            setIframeSrc(`${appUrl}excel_report/ckers_finance_combine_report.php?id=${randomNumberInRange(1111, 9999)}&brief=${brief}&param1=${param1}`); 
            setIframeLoaded(false); 
    }, [setIframeLoaded]); 

    const handleIframeLoad = () => {
        setIframeLoaded(true);
      };


  // Function to export data to Excel
  const exportToExcel = () => {
    const timestamp = Date.now();
    const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    const fileExtension = '.xlsx';
    const formattedData = data.map(({ name, age, gender }) => ({ Name: name, Age: age, Gender: gender }));
    const ws = XLSX.utils.json_to_sheet(formattedData);
    const wb = XLSX.utils.book_new(); // Create a new Workbook
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1'); // Append the worksheet to the Workbook
    const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' }); // Write the Workbook to a buffer
    const dataBlob = new Blob([excelBuffer], { type: fileType });
    saveAs(dataBlob, `Ckers_Finance_Combine_Report_${timestamp}${fileExtension}`);
  };
 

// Columns for DataTable
  const columns = [
    {
      name: 'Name',
      selector: (row) => row.name,
      sortable: true,
    },
    {
      name: 'Age',
      selector: (row) => row.age,
      sortable: true,
    },
    {
      name: 'Gender',
      selector: (row) => row.gender,
      sortable: true,
    },
    {
        name: 'Email',
        selector: (row) => row.email,
        sortable: true,
      },
      {
        name: 'Phone',
        selector: (row) => row.phone,
        sortable: true,
      },
      {
        name: 'Address',
        selector: (row) => row.address,
        sortable: true,
      },
      {
        name: 'Pincode',
        selector: (row) => row.pincode,
        sortable: true,
      }, 
      
      {
        name: 'Office',
        selector: (row) => row.office,
        sortable: true,
      }, 
  ];
      const data = [
        { id: 1, name: 'John', age: 30, gender: 'Male',email:'nspresponsive@gmail.com',phone:'9999401224', address:'New Delhi',pincode: '110065', office: "Ckers - MAG" },
        { id: 1, name: 'John', age: 30, gender: 'Male',email:'nsp@gmail.com',phone:'9999401224', address:'New Delhi',pincode: '110065', office: "Ckers - MAG" },
        { id: 1, name: 'John', age: 30, gender: 'Male',email:'nsp@gmail.com',phone:'9999401224', address:'New Delhi',pincode: '110065', office: "Ckers - MAG" },
        { id: 1, name: 'John', age: 30, gender: 'Male',email:'nsp@gmail.com',phone:'9999401224', address:'New Delhi',pincode: '110065', office: "Ckers - MAG" },
        { id: 1, name: 'John', age: 30, gender: 'Male',email:'nsp@gmail.com',phone:'9999401224', address:'New Delhi',pincode: '110065', office: "Ckers - MAG" },
        { id: 1, name: 'John', age: 30, gender: 'Male',email:'nsp@gmail.com',phone:'9999401224', address:'New Delhi',pincode: '110065', office: "Ckers - MAG" },
        { id: 1, name: 'John', age: 30, gender: 'Male',email:'nsp@gmail.com',phone:'9999401224', address:'New Delhi',pincode: '110065', office: "Ckers - MAG" },
        { id: 1, name: 'John', age: 30, gender: 'Male',email:'nsp@gmail.com',phone:'9999401224', address:'New Delhi',pincode: '110065', office: "Ckers - MAG" },
        { id: 1, name: 'John', age: 30, gender: 'Male',email:'nsp@gmail.com',phone:'9999401224', address:'New Delhi',pincode: '110065', office: "Ckers - MAG" },
        { id: 1, name: 'John', age: 30, gender: 'Male',email:'nsp@gmail.com',phone:'9999401224', address:'New Delhi',pincode: '110065', office: "Ckers - MAG" },
      ];

    return (
        <>
            <Helmet>
                <title> All Campaigns | Ckers </title>
            </Helmet>

            <Container>
                <div className="d-flex align-items-center justify-content-between">
                    <span>&nbsp;</span>                 
                </div> 
                    <>

                   {/* <div className>
                        <button onClick={exportToExcel} className="btn btn-primary float-right">Download Report</button>
                        <DataTable
                                columns={columns}
                                data={data}
                                pagination
                                highlightOnHover
                                searchable 
                                responsive 
                            />
                        </div>
    */}
                    
                        <div id='main-wrap-' className='mmt-7-'>
                            <div className='row justify-content-between mb-3 d-none'>
                                <div className='col-md-8'> 
                                <Typography className='line-initial' variant="h4" sx={{ mb: 0 }}>
                                    { /* {pageHeading} */ }
                                </Typography>
                                </div>
                                <div className='col-md-4 pe-0 ps-lg-5'>
                                    &nbsp;
                                </div>
                            </div>
                            <div className='table-wrap'>
                            {!iframeLoaded && <div><div className='p-spinner'><div className="spinner">&nbsp;</div></div></div>}
                                <iframe
                                    title="Report"
                                    width="100%"
                                    height="600"
                                    src= {iframeSrc}
                                    frameBorder="0"
                                    allowFullScreen
                                    onLoad={handleIframeLoad}
                                    style={{ display: iframeLoaded ? 'block' : 'none' }}
                                 />
                            </div>
                        </div>
                    </> 
            </Container>
 
        </>
    );
}

function mapStateToProps(state) {
    return {
        campaignData: state.campaignData,
        getUserModuleData: state.getUserModuleData,
    }
} 

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(Object.assign(userActions.default, leadActions.default, campaignsActions.default), dispatch),
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(CkersFinanceCombineReport);